<fcom-generic-icon [iconRef]="iconRef()" [url]="svgPath()" />
@if (informative()) {
  <span class="is-vishidden">{{ 'icons.' + name() | finLocalization }}</span>
}
